export default (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  // const re = new RegExp('^([0-9]|[/]|[\\]|[ ]|[.]|[ก-๙])+$', 'g').test(
  //   value
  // );
  const re = new RegExp(/[\u0E00-\u0E7F]/, 'g').test(value);

  return re;
};
